var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('slider'),_c('alert-section'),_c('statistics-section'),_c('catalogue-section'),_c('last-stream-section'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }